import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AgentDto, TicketAdditionalFileDto, TicketDto, TicketElementDto, TicketStepDto, FileUploadDto, TicketOperationalNoteDto } from '../../../../../service/dto';
import { finalize, of, Subscription } from 'rxjs';
import { HttpFileService } from '../../../../../service/http-file.service';
import { HttpEventType } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzSelectOptionInterface } from 'ng-zorro-antd/select';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormControlWrapper } from '../../../../../components/dynamic-form/dynamic-form-abstract';
import { HttpTicketService } from '../../../../../service/http-ticket.service';

@Component({
	selector: 'app-ticket-form-section-operations',
	standalone: false,
	templateUrl: './ticket-form-section-operations.component.html',
	styleUrl: './ticket-form-section-operations.component.scss'
})
export class TicketFormSectionOperationsComponent implements OnInit {
	@Input() ticket!: TicketDto;
	@Input() step!: TicketStepDto;
	@Input() formControls!: FormControlWrapper[];
	@Input() readonly!: boolean;
	@Input() masterForm!: FormGroup;
	availableAgents: AgentDto[] = [];

	constructor(
		private fb: FormBuilder,
		private modal: NzModalService,
		private ticketService: HttpTicketService) {
	}

	ngOnInit(): void {
		this.readonly = this.step.isCurrentState == false;
		if(!this.readonly){
			if(!this.ticket.id){
				this.ticketService.getOnCreateAvailableAgents(this.ticket.workflowId).subscribe(result => this.availableAgents = result);
			}
		}
	}
}
